import AddNoteModal from './AddNoteModal';

export default AddNoteModal;
